export default __webpack_public_path__ + "pam@2x.5881acef.png";